<template>
    <div>
        <div class="modal fade" id="addCategoryModal" tabindex="-1" role="dialog" aria-labelledby="addCategoryModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <form method="POST"  @submit.prevent="save">
                        <div class="modal-header">
                            <h5 class="modal-title" id="addCategoryModalLabel">Add Category</h5>
                            <button type="button" class="close" @click="closeModal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="category-name" class="col-form-label">Name:</label>
                                <input required v-model="form.name" type="text" class="form-control" id="category-name">
                            </div>
                            <div class="form-group">
                                <label for="category-parent" class="col-form-label">Parent Category:</label>
                                <select v-model="form.parent_id" id="category-parent" class="form-control">
                                    <option value="">Select Category</option>
                                    <option v-for="(category,id) in categories" :value="category.id">{{category.name}}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="category-description" class="col-form-label">Description:</label>
                                <textarea v-model="form.description" type="text" class="form-control" id="category-description"></textarea>
                            </div>
                            <div class="form-group">
                                <label for="category-image" class=" col-form-label">Image</label>
                                <input type="file" v-on:change="uploadImage($event)" accept="image/*" name="image" class="form-control-file" id="chooseFile">
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                            <button type="submit" class="btn btn-primary">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "add-category-modal",
        components: {
        },
        props: {
            categories: Array,
        },
        mounted() {
            window.setTimeout(function() {
                $('#addCategoryModal').modal({backdrop: 'static', keyboard: false})
                $('#addCategoryModal').modal('toggle');
            }, 200);
        },
        data: function() {
            return {
               form: {
                    name: '',
                    description: '',
                    parent_id: '',
                    image: '',
               }
            }
        },
        methods: {
            uploadImage: function(e) {
               this.form.image  =  e.target.files[0];
            },
            save: function() {
                let self = this;
                let $end = '/api/add-category-api';
                let data = new FormData();
                data.append('name', this.form.name);
                data.append('image', this.form.image);
                data.append('description', this.form.description);
                data.append('parent_id', this.form.parent_id);
                data.append('api', true);

                axios.post($end, data).then(response  => {
                    let res = response.data;
                    self.$emit('update-categories', {update: true, category: res});
                    $('#addCategoryModal').modal('hide');
                }).catch(err => {
                    this.$data.loader = false;
                });
            },
            closeModal: function() {
                this.$emit('update-categories', {update: false});
                $('#addCategoryModal').modal('hide');
            },
        },
    }
</script>
